import React, { useState, useEffect, useReducer } from 'react';
import { useViewPort } from '../Hooks/useViewPort';
import '../gdacs_2.0.css';

const GdacsHeader = (props) => {
    const { width } = useViewPort();

    return (
        <div id="header" className="container-fluid">
            <div id="top_menu">
                <div className="container">
                    <div className="float-right gdacs_top_menu_content"><a href="http://www.gdacs.org/About/contactus.aspx">contact us</a></div>
                    <div className="float-right gdacs_top_menu_content"><a href="http://www.gdacs.org/About/termofuse.aspx">term of use</a></div>

                </div>
            </div>
            <div id="heading" className="container">
                <div id="rowhead" className="row">
                    <div id="gd_logo" className="d-flex justify-content-center col-lg-4 gdacs_logo">
                        <img id="gdacs_logo_image" src="images/gdacs_logo_ecs_medium3.png" />
					</div>
                    <div id="gd_statement" className="d-none d-lg-block col-md-5 gdacs_statement"> GDACS is a cooperation framework between the United Nations, the European Commission and disaster managers worldwide to improve awareness, information exchange and coordination in the first phase after major sudden-onset disasters.</div>
                        <div id="gd_uneu" className="d-none d-lg-block col-md-3 gdacs_uneu">
                            <img src="images/un_eu.png" />
					</div>
                </div>
            </div>

        </div>

    );
}

export { GdacsHeader };